function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { createEditorPlatformManifestServicesError, EditorPlatformManifestServicesErrorCode } from '../errors';

/**
 * there is already no product requirements to keep mappings as an array,
 * so basically we can
 *  style: Record<string, IManifestItemMapping[]>;
 *  ->
 *   style: Record<string, IManifestItemMapping>;
 *
 * but lets keep for now as array to keep the flexibility in case if something
 * will be changed
 *
 * TODO:
 * do we need support for:
 *  - visibleState
 *  - displayFilters
 *  - displayFilters
 */
var _manifests = /*#__PURE__*/new WeakMap();
export class ManifestRuntimeContext {
  constructor() {
    _classPrivateFieldInitSpec(this, _manifests, new Map());
  }
  getAll() {
    return Object.fromEntries(_classPrivateFieldGet(_manifests, this).entries());
  }
  register(context) {
    if (_classPrivateFieldGet(_manifests, this).has(context.manifestId)) {
      throw createEditorPlatformManifestServicesError(EditorPlatformManifestServicesErrorCode.ContextualManifestAlreadyRegistered);
    }
    _classPrivateFieldGet(_manifests, this).set(context.manifestId, context);
  }
  clean(id) {
    _classPrivateFieldGet(_manifests, this).delete(id);
  }
  getRuntimeContext(manifestContextId) {
    return _classPrivateFieldGet(_manifests, this).get(manifestContextId);
  }
  getManifest(manifestContextId) {
    var _this$getRuntimeConte;
    return (_this$getRuntimeConte = this.getRuntimeContext(manifestContextId)) == null ? void 0 : _this$getRuntimeConte.tree.manifest;
  }
  replaceManifestContext(manifestId, manifest) {
    if (manifest) {
      _classPrivateFieldGet(_manifests, this).set(manifestId, manifest);
    } else {
      _classPrivateFieldGet(_manifests, this).set(manifestId, getEmptyManifestContext(manifestId));
    }
  }
  async map(cb) {
    _classPrivateFieldGet(_manifests, this).forEach(manifest => {
      this.replaceManifestContext(manifest.manifestId, cb(manifest));
    });
  }
}
export const getEmptyManifestContext = manifestId => {
  return {
    manifestId,
    isStageBound: false,
    manifests: [],
    tree: {
      editorPointer: null,
      extensionType: null,
      manifest: getEmptyManifest(),
      mappings: {
        cssProperties: {},
        cssCustomProperties: {},
        data: {},
        actions: {},
        customActions: {},
        states: {},
        presets: {},
        layout: {}
      },
      children: []
    },
    handlers: null
  };
};
export const getEmptyManifest = () => {
  return {
    editorElement: {
      style: {},
      data: {},
      actions: {},
      customActions: {},
      layout: {}
    }
  };
};
//# sourceMappingURL=ManifestRuntimeContext.js.map